import { render } from "./Section.vue?vue&type=template&id=e81b3e36&scoped=true&ts=true"
import script from "./Section.vue?vue&type=script&lang=ts"
export * from "./Section.vue?vue&type=script&lang=ts"

import "./Section.vue?vue&type=style&index=0&id=e81b3e36&lang=scss&scoped=true"

import exportComponent from "D:\\Karol\\Documents\\Github\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e81b3e36"]])

export default __exports__